import $ from 'jquery';

const AdministrationTaskLists = {
  init() {
    // used in #index
    this.enableTaskListSelectForDeletion();

    // used in #form
    this.enableFormButtons();
    this.enableVehicleSelect();
  },

  enableTaskListSelectForDeletion() {
    $('.js-toggle-day-for-deletion').on('click', (event) => {
      const checkBoxes = $(event.target).closest('table').find('.js-delete-flag:checkbox');
      checkBoxes.click();
      return event.preventDefault();
    });
  },

  enableFormButtons() {
    // Bind idempotently: init() runs on every turbo:load, so unbind our
    // namespaced delegated handler before re-binding to avoid accumulating
    // duplicate handlers across Turbo visits.
    $('form')
      .off('click.turboLifecycle', '.js-remove-row')
      // eslint-disable-next-line prefer-arrow-callback -- for consistency with below addRow lint disabling
      .on('click.turboLifecycle', '.js-remove-row', function removeRow(event) {
        const row = event.target.closest('tr');
        const idField = row.querySelector('input[name$="[id]"]');
        const removeFlag = row.querySelector('.js-remove-flag');

        if (idField && idField.value && removeFlag) {
          removeFlag.value = '1';
          row.style.display = 'none';
        } else {
          row.remove();
        }

        event.preventDefault();
      });

    $('form')
      .off('click.turboLifecycle', '.js-add-row')
      // eslint-disable-next-line prefer-arrow-callback -- addRow function name is referenced in a ruby code comment
      .on('click.turboLifecycle', '.js-add-row', function addRow(event) {
        const table = document.querySelector(event.target.dataset.table || '#pausesTable');
        const lastRow = table.querySelector('tr:last-of-type');

        // Every row of line stops needs a unique id.
        const time = Date.now();
        const regexp = new RegExp(event.target.dataset.id, 'g');
        const newRowHTML = event.target.dataset.fields.replace(regexp, time);
        const newRow = document.createElement('tr');
        newRow.innerHTML = newRowHTML;

        lastRow.insertAdjacentElement('afterend', newRow);

        event.preventDefault();
      });
  },

  enableVehicleSelect() {
    const vehicleSelect = $('.js-vehicle-select');
    const checkAdHocbook = $('.js-tasklist-ad-hoc-bookable');
    const checkPrebook = $('.js-tasklist-prebookable');

    if (!vehicleSelect.length) return;

    vehicleSelect.on('change', (e) => {
      const optionData = $(e.target).find(':selected').data();

      checkAdHocbook.prop('checked', optionData.adHocBookable);
      checkPrebook.prop('checked', optionData.prebookable);
    });
  }
}

export default AdministrationTaskLists;
